<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? $t("AJOUTER_UNE") : $t("MODIFICATION_DE") }} {{$t("LETTER")}}  </h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>
      <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
        <div class="p-6">
         
          <p class="pt-4" >{{ $t("card") }}<b style="color: #ff6141">*</b></p>
          <v-select
            v-validate="'required'"
            name="card"
            class="w-full" label="code"
            v-model="input.card"
            :options="paginated"
            :filterable="false"
            @open="onOpen"
            @close="onClose"
            @search="(query) => (searchRech = query)"
            @input="onOwnerSelect"
            >
            <template #list-footer>
              <li v-show="hasNextPage" ref="load" class="loader">
                Loading...🔄
              </li>
            </template>
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('card')">{{$t("card_error")}}</span>

          <p class="pt-4">{{ $t("type_personne") }} <b style="color: #ff6141">*</b></p>
          <div class="flex flex-row space-x-6">
            <label
              v-for="type in types"
              :key="type.key"
              class=" pt-4 flex items-center space-x-2"
            >
              <input
                type="radio"
                :value="type.key"
                v-model="input.type"
                name="type_personne"
                v-validate="'required'"
                data-vv-name="type_personne"
              />
              <span>{{ type.name }}</span>
            </label>
          </div>
          <span class="text-danger text-sm" v-show="errors.has('type_personne')">{{ $t("type_personne_error") }}</span>

          <p v-if="input.type === 'beneficiary'" class="pt-4">{{ $t("beneficiaire") }} <b style="color: #ff6141">*</b></p>
          <v-select
            v-if="input.type === 'beneficiary'"
            :key="input.type"
            v-validate="'required'"
            name="recipient_id"
            :reduce="rep => rep.id"
            class="w-full"
            label="fullName"
            v-model="input.recipient_id"
            :options="beneficiaries">
          </v-select>
          <span v-if="input.type === 'beneficiary'" class="text-danger text-sm" v-show="errors.has('recipient_id')">
            {{ $t("beneficiarie_error") }}
          </span>
      
          <p class="pt-4">{{ $t("healthFacilityTypes") }}<b style="color: #ff6141">*</b></p>

          <v-select
          v-validate="'required'"
          name="healthFacilityType"
          class="w-full" label="name"
          :reduce="(rep) => rep.id"
          v-model="healthFacilityType"
          :options="healthFacilityTypes"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('healthFacilityType')">{{$t("healthFacilityTypes_error")}}</span>


          <p class="pt-4" >{{ $t("healthFacility") }}<b style="color: #ff6141">*</b></p>
          <v-select
          v-validate="'required'"
          name="healthFacility"
          class="w-full" label="name"
          :reduce="(rep) => rep.id"
          v-model="input.healthFacility"
          :options="healthFacilities"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('healthFacility')">{{$t("healthFacility_error")}}</span>

          <p class="pt-4" >{{ $t("acte") }}<b style="color: #ff6141">*</b></p>
          <v-select
          multiple
          v-validate="'required'"
          name="acte"
          class="w-full" label="name"
          v-model="input.acts"
          :reduce="(rep) => rep.id"
          :options="acts_list"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('acte')">{{$t("act_error")}}</span>

        </div>
      </component>
  
      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="submit_validate">{{$t("Soumettre")}}</vs-button>
        <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t("Annuler")}}</vs-button>
      </div>
    </vs-sidebar>
  </template>
  
<script>
  
// For custom error message
import { Validator } from 'vee-validate'
  
const dict = {
  custom: {
    card: {
      required: 'Le champ carte est obligatoire'
    },
    healthFacility: {
      required: 'Le champ région est obligatoire'
    },
    acte: {
      required: 'Le champ acte est obligatoire'
    }

  }
}
  
// register custom messages
Validator.localize('en', dict)
  
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  
const input_tempon = {
  card: '',
  healthFacility: '',
  recipient_id:'',
  type: '',
  acts:[]
}
  
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      ismChekced: false,
      healthFacilityTypes: [],
      healthFacilityType:'',
      beneficiaries: [],
      types: [
        {
          key: 'member',
          name: 'Adhérent'
        },
        {
          key: 'beneficiary',
          name: 'Bénéficiaire'
        }
      ],
      oldVal: null,
      user_role:'',
      observer: null,
      limit: 10,
      searchRech: '',
      healthFacilities: [],
      acts_list: [],
      cards:[],
      input: JSON.parse(JSON.stringify(input_tempon)),
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    healthFacilityType (newVal) {
      if (newVal) {
        
        this.healthFacilities = []

        /* if (this.oldVal === null) {
          this.oldVal = this.healthFacilityType
        } 
        if (!this.input.id) {
          this.input.healthFacility = null
        } */
        if (this.oldVal !== newVal) {
          this.input.healthFacility = null
        } 
        /*  this.$http.post('health-facilities-by-type/', { facilityTypeId: newVal })
          .then(response => {
            this.healthFacilities = response.data         
          }) */

        this.$http.post('ism-owner-healthFacilities/', { card_id:this.input.card.id, healthFacilityType_id :newVal })
          .then(response => {
            this.healthFacilities = response.data        
            if (response.data.length === 1) {
              this.input.acts = []
              this.acts_list.length = 0
              this.getAllacts_ism()
            } else {
              this.input.acts = []
              this.acts_list.length = 0
              this.getAllacts() 
            } 
          })  
                
      } else {
        this.healthFacilities = []
        this.input.acts = []
        this.acts_list.length = 0
        this.input.healthFacility = null
      } 
    },
    'input.card' (newVal) {
      if (newVal) {
        //this.input.healthFacility = null
        const card_id = newVal.id
        this.beneficiaries = []
        if (this.healthFacilityType) {
          this.$http.post('ism-owner-healthFacilities/', { card_id, healthFacilityType_id : this.healthFacilityType })
            .then(response => {
              this.healthFacilities = response.data
              if (response.data.length === 1) {
                this.input.acts = []
                this.acts_list.length = 0
                this.getAllacts_ism()
              } else {
                this.input.acts = []
                this.acts_list.length = 0
                this.getAllacts() 
              } 
            })   
        }   
        this.$http.post('card-beneficiaries/', {card_id: newVal.id})
          .then(response => {
            this.beneficiaries = response.data.filter(item => item.fullName !== null)          
          })
          .catch(error => {
            this.$vs.notify({
              title: 'ERREUR',
              text: `Echec de la récupération des bénéficiaires :${  error.response.data.message}`,
              color: 'warning',
              position: 'top-right'
            })
          })
        
      } else {
        this.input.healthFacility = null
        this.healthFacilities = []
        this.input.acts = []
        this.acts_list.length = 0
        this.input.card = null
        
      } 
    },
    
    'input.acts' (newVal) {
      if (this.user_role !== 'admin' && newVal.length > 3) {
        this.input.acts = newVal.slice(0, 3)
        this.$vs.notify({
          title: this.$t('message_titre'),
          text: this.$t('message_limite'),
          color: 'warning',
          position: 'top-right'
        })
      }
    },
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        this.input = JSON.parse(JSON.stringify(this.data))
        this.healthFacilityType = this.data.healthFacility.healthFacilityType.id
        this.oldVal = this.healthFacilityType
        this.$http.post('card-beneficiaries/', {card_id: this.data.card.id})
          .then(response => {
            this.beneficiaries = response.data.filter(item => item.fullName !== null)   
            const found = this.beneficiaries.find(item => item.fullName === this.data.fullName)
            if (found) {
              this.input.recipient_id = JSON.parse(JSON.stringify(found.id))
            }       
          })
        this.input.healthFacility = this.data.healthFacility.id
      
        
        this.input.acts = []
        for (let i = 0; i < this.data.acts.length; i++) {
          this.input.acts.push(this.data.acts[i].act.id)
        }
        this.initValues()
      }
    }
  },
  
  computed: {
    filtered () {
      return this.cards.filter((card) => card.code.toLowerCase().includes(this.searchRech.toLowerCase())
      )
    },
    paginated () {
      return this.filtered.slice(0, this.limit)
    },
    hasNextPage () {
      return this.paginated.length < this.filtered.length
    },
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    onOwnerSelect (selectedId) {
      if (selectedId) {
        const selected = this.paginated.find(item => item.id === selectedId.id)
        this.code = selected ? selected.code : ''
      }
    },
    initValues () {
      if (this.data.id) return
      this.input = JSON.parse(JSON.stringify(input_tempon))
      this.healthFacilityType = ''
    },
    submit_validate () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.submitData()
        }
      })
    },
    async onOpen () {
      if (this.hasNextPage) {
        await this.$nextTick()
        this.observer.observe(this.$refs.load)
      }
    },
    onClose () {
      this.observer.disconnect()
    },
    async infiniteScroll ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = ul.scrollTop
        this.limit += 10
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async submitData () {
      this.$vs.loading()
      const input = JSON.parse(JSON.stringify(this.input))
      input.card = this.input.card.id

      let url = 'letters/'
      let methods = 'post'
      const message = {
        error: this.$t('save_error'),
        success: this.$t('letter_save')
      }
      if (input.id) {
        url += `${input.id}/`
        methods = 'put'
        message.success = this.$t('letter_update')
      }
  
      this.$http[methods](url, input)
        .then((response) => {
          window.letters.getAllletters()
          window.getPrendTaCom.success(message.success, response)
          this.$emit('closeSidebar')
          this.initValues()
        })
        .catch((error) => {
  
          const clefs = Object.keys(error.response.data)
          for (let i = 0; i < clefs.length; i++) {
            const item = clefs[i]
            let libelle = ''
            if (item === 'card') {
              libelle = this.$t('card')
            }
            if (item === 'healthFacility') {
              libelle = this.$t('healthFacility')
            }
            if (item === 'acts') {
              libelle = this.$t('acts')
            }
            for (let j = 0; j < error.response.data[item].length; j++) {
              window.getPrendTaCom.error(`${libelle} :  ${error.response.data[item][j]}`)
            }
          }
  
          window.getPrendTaCom.error(message.error)
        })
    },
    getAllcards () {
      this.$vs.loading()
      this.$http.get('lite-cards/')
        .then(({ data }) => {
          this.cards = data.map(card => ({
            ...card,
            code: `${card.code} | ${card.fullName}`
          }))
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    getAllhealthFacilities () {
      this.$vs.loading()
      this.$http.get('light-healthFacilities/')
        .then((response) => {
          this.healthFacilities = response.data
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    getAllacts () {
      this.$vs.loading()
      //this.this.acts_list = []
      this.$http.get('list-light-acts/')
        .then((response) => {
          this.acts_list = response.data
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    getAllacts_ism () {
      this.$vs.loading()
      //this.this.acts_list = []
      this.$http.get('ism-acts/')
        .then((response) => {
          this.acts_list = response.data
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    getAllhealthFacilitiesTypes () {
      this.$vs.loading()
      this.$http.get('healthFacilityTypes/')
        .then((response) => {
          this.healthFacilityTypes = response.data
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    }
  
  },
  created () {
    this.user_role = JSON.parse(localStorage.getItem('userInfo')).role
    //this.user_corporate_id = JSON.parse(localStorage.getItem('userInfo')).corporate.id 
    /* if (this.user_corporate_id !== 22) {
      this.ismChekced = true
      this.getAllhealthFacilities()
    } else {
      this.ismChekced = false
    } */
    this.getAllhealthFacilitiesTypes()
    this.getAllhealthFacilities()
    this.getAllacts()
  },
  mounted () {
    this.observer = new IntersectionObserver(this.infiniteScroll)
    this.getAllcards()
    this.isMounted = true
  }
}
</script>
  
  <style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }
  
    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;
  
      .img-upload {
        margin-top: 2rem;
  
        .con-img-upload {
          padding: 0;
        }
  
        .con-²-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }
  
  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
  
    &:not(.ps) {
      overflow-y: auto;
    }
  }
  </style>
  